import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-ban",
  "use": "icon-s-ban-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-ban\"><path d=\"M11 0c6.075 0 11 4.925 11 11s-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0M2 11a9 9 0 0 0 14.617 7.032L3.967 5.382A8.96 8.96 0 0 0 2 11m9-9a8.96 8.96 0 0 0-5.617 1.968l12.65 12.65A9 9 0 0 0 11 2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol